// Arabic module 09 strings — DEVELOPMENT DRAFT by Claude (PD-011); unreviewed until decision H-10.
import type { enContractors } from './en-contractors.ts';
import type { Message } from './types.ts';

export const arContractors: { readonly [K in keyof typeof enContractors]: Message } = {
  'ctr.api.affiliationOverlap': 'يعمل هذا الشخص لدى شركة في تلك الفترة. أنهِ الارتباط الحالي أولًا.',
  'ctr.api.alreadySuspended': 'هذا السجل موقوف بالفعل.',
  'ctr.api.notSuspended': 'هذا السجل غير موقوف.',
  'ctr.api.deliveryArrived': 'وصلت هذه الشحنة بالفعل أو أُلغيت.',
  'ctr.api.deliveryClosed': 'تم تسجيل نتيجة الطرد لهذه الشحنة بالفعل.',
  'ctr.api.deliveryNotArrived': 'سجّل وصول الشحنة قبل تسليمها.',
  'ctr.api.evidenceDecided': 'تمت مراجعة هذا الإثبات بالفعل. قدّم بديلًا لتغييره.',
  'ctr.api.evidenceSuperseded': 'حلّت نسخة أحدث مقبولة محل هذا الإثبات.',
  'ctr.api.fileAlreadyAttached': 'يوجد ملف مرفق بهذه النسخة بالفعل. قدّم بديلًا بدلًا من ذلك.',
  'ctr.api.noHandoverArea': 'لا توجد منطقة تسليم معتمدة مفتوحة. افتح منطقة أو ارفض الشحنة — لا يُوجَّه المندوبون أبدًا عبر مسار الزوار.',
  'ctr.api.notOnsite': 'لا يوجد وصول مسجّل، لذلك لا توجد مغادرة لتسجيلها.',
  'ctr.api.ownSubmission': 'أنت من أعدّ هذا أو قدّمه، لذا يجب أن يقرّر فيه مراجع آخر.',
  'ctr.api.periodEnded': 'انتهت فترة الدخول هذه.',
  'ctr.api.periodHostInactive': 'المضيف المسؤول عن فترة الدخول هذه غير نشط. أعِد إسنادها قبل إنشاء الزيارات.',
  'ctr.api.permitClosed': 'تم سحب هذا التصريح.',
  'ctr.api.permitDraftNotWithdrawable': 'هذا التصريح ما زال مسودة ولم يُقدَّم، لذا لا يمكن سحبه. عدّله أو اتركه دون تقديم.',
  'ctr.api.permitNotEditable': 'لا يمكن تقديم إلا تصريح مسودة أو مرفوض أو مُبطَل.',
  'ctr.api.permitNotReady': 'لا يمكن اعتماد التصريح حتى تُقبل الإثباتات المطلوبة وتكون صالحة طوال مدة التصريح.',
  'ctr.api.permitNotSubmitted': 'هذا التصريح ليس بانتظار قرار.',
  'ctr.api.scanPending': 'لم يجتز الملف فحص البرمجيات الضارة، لذلك لا يمكن معاينته أو قبوله.',
  'ctr.api.taskResolved': 'تمت معالجة مهمة الاسترداد هذه بالفعل.',
  'ctr.api.typeRetired': 'نوع الإثبات هذا غير موجود في المتطلبات الحالية، لذلك لا يمكن قبوله.',
  'ctr.api.workPackageClosed': 'حزمة العمل هذه مغلقة.',

  'ctr.v.affiliationUnknown': 'اختر ارتباط عامل حاليًا.',
  'ctr.v.backupSame': 'يجب أن يكون الراعي البديل شخصًا مختلفًا.',
  'ctr.v.categoryNotContractor': 'اختر فئة زوار نشطة تخضع لمتطلبات المقاولين.',
  'ctr.v.companyNotActive': 'هذه الشركة موقوفة أو غير نشطة.',
  'ctr.v.companyUnknown': 'اختر شركة مسجّلة.',
  'ctr.v.confirmImpact': 'راجع الأثر ثم أكّد.',
  'ctr.v.deliveryPointExists': 'هذا الموقع منطقة تسليم بالفعل.',
  'ctr.v.deliveryPointUnknown': 'اختر منطقة تسليم معتمدة في هذا الموقع.',
  'ctr.v.emptyRule': 'يجب أن تتطلب القاعدة نوع إثبات واحدًا على الأقل.',
  'ctr.v.evidenceType': 'ارفع ملف PDF أو PNG أو JPEG.',
  'ctr.v.expiryRequired': 'يحتاج نوع الإثبات هذا إلى تاريخ انتهاء قبل قبوله.',
  'ctr.v.handedToRequired': 'حدّد من استلم الطرد.',
  'ctr.v.issuerRequired': 'يحتاج نوع الإثبات هذا إلى جهة إصدار قبل قبوله.',
  'ctr.v.moveBeforeStart': 'يجب أن يبدأ الارتباط الجديد بعد بدء الارتباط الحالي.',
  'ctr.v.permitTooLong': 'يمكن أن تستمر تصاريح هذا النوع {days} يومًا كحد أقصى.',
  'ctr.v.permitTypeUnknown': 'اختر نوع تصريح نشطًا.',
  'ctr.v.plate': 'استخدم حروفًا أو أرقامًا أو مسافات أو شرطات (حتى 20).',
  'ctr.v.reasonRequired': 'اذكر السبب.',
  'ctr.v.referenceTaken': 'هذا المرجع مستخدم بالفعل في هذا الموقع.',
  'ctr.v.registrationTaken': 'لدى شركة أخرى مرجع التسجيل هذا.',
  'ctr.v.replacesMismatch': 'يجب أن يكون البديل من نوع الإثبات نفسه وللجهة والموقع أنفسهم.',
  'ctr.v.sameCompany': 'اختر شركة مختلفة.',
  'ctr.v.unknownType': 'يشير إلى نوع إثبات غير موجود هنا.',
  'ctr.v.userUnavailable': 'اختر زميلًا نشطًا.',
  'ctr.v.workPackageClosed': 'حزمة العمل هذه مغلقة.',
  'ctr.v.workPackageUnknown': 'اختر حزمة عمل لهذه الشركة في هذا الموقع.',
  'ctr.v.workerUnknown': 'هذا الشخص ليس عاملًا مسجّلًا لدى مقاول.',
  'ctr.v.workersInvalid': 'اختر عمالًا حاليين لدى الشركة المحددة.',
  'ctr.v.unknown_type': 'اختر نوع إثبات مُعدًّا.',
  'ctr.v.subject_mismatch': 'ينتمي نوع الإثبات هذا إلى جهة مختلفة (شركة أو عامل أو ارتباط).',
  'ctr.v.site_required': 'هذا الإثبات خاص بموقع: اختر الموقع الذي أُعطي له.',
  'ctr.v.site_not_allowed': 'ينطبق نوع الإثبات هذا على كل المواقع؛ لا تختر موقعًا.',
  'ctr.v.validity_order': 'يجب أن يكون تاريخ الانتهاء في تاريخ البدء أو بعده.',
  'ctr.v.validity_too_long': 'هذه الصلاحية أطول مما يسمح به النوع.',
  'ctr.v.period.work_package_closed': 'حزمة العمل مغلقة.',
  'ctr.v.period.outside_work_package': 'يجب أن تقع الفترة ضمن تواريخ حزمة العمل.',
  'ctr.v.period.order': 'يجب أن تكون النهاية في البداية أو بعدها.',
  'ctr.v.period.daily_order': 'يجب أن تكون نهاية اليوم بعد بدايته.',
  'ctr.v.period.too_long': 'يمكن أن تستمر الفترة سنة واحدة كحد أقصى.',

  'ctr.block.not_affiliated': 'ليس عاملًا حاليًا لدى شركة مسجّلة طوال المدة.',
  'ctr.block.company_suspended': 'الشركة موقوفة.',
  'ctr.block.company_inactive': 'الشركة غير نشطة.',
  'ctr.block.person_suspended': 'هذا العامل موقوف.',
  'ctr.block.sponsor_reassignment_required': 'ليس لدى الشركة راعٍ مسؤول نشط. أعِد إسناد الراعي.',
  'ctr.block.evidence': '{type}: {status}',
  'ctr.block.permit_required': 'تحتاج المنطقة المقيدة إلى تصريح معتمد يشمل هذا العامل والمنطقة والمدة كاملة.',
  'ctr.block.permit_evidence': 'إثبات التصريح — {type}: {status}',
  'ctr.block.work_package_closed': 'حزمة العمل مغلقة.',
  'ctr.block.outside_work_package': 'الزيارة خارج تواريخ حزمة العمل.',
  'ctr.block.access_period_ended': 'انتهت فترة الدخول.',
  'ctr.block.outside_access_period': 'الزيارة خارج فترة الدخول المعتمدة.',
  'ctr.req.satisfied': 'مقبول وصالح',
  'ctr.req.missing': 'غير موجود',
  'ctr.req.awaiting_file': 'بانتظار الرفع',
  'ctr.req.scan_pending': 'فحص البرمجيات الضارة قيد الانتظار',
  'ctr.req.scan_failed': 'الفحص غير متاح',
  'ctr.req.review_pending': 'المراجعة قيد الانتظار',
  'ctr.req.rejected': 'مرفوض',
  'ctr.req.expires_in_window': 'ينتهي قبل نهاية المدة',
  'ctr.req.not_yet_valid': 'غير ساري بعد',
  'ctr.permit.p.company_not_active': 'الشركة موقوفة أو غير نشطة.',
  'ctr.permit.p.type_inactive': 'نوع التصريح هذا غير نشط.',
  'ctr.permit.p.too_long': 'المدة أطول مما يسمح به نوع التصريح.',
  'ctr.permit.p.no_workers': 'حدّد عاملًا واحدًا على الأقل.',
  'ctr.permit.p.worker_suspended': '{worker} موقوف.',
  'ctr.permit.p.affiliation_window': 'لا يعمل {worker} لدى هذه الشركة طوال مدة التصريح.',
  'ctr.permit.p.evidence': '{worker} — {type}: {status}',

  'ctr.mail.deliverySubject': 'شحنة بانتظارك — {reference}',
  'ctr.mail.deliveryBody': 'مرحبًا {name}،\n\nلدى {courier} شحنة لك في {site} (عدد الطرود: {count}، المرجع {reference}).\nمنطقة التسليم: {point}. {route}\n\nلا يسجّل هذا الإشعار أي تسليم: يسجّل المكتب ما إذا سُلِّم الطرد أو رُفض.',

  'ctr.tab.permits': "تصاريح العمل",
  'ctr.tab.companies': "الشركات والعمال",
  'ctr.tab.evidence': "سجل الإثباتات",
  'ctr.tab.rules': "قواعد الإثبات",
  'ctr.ui.intro': "أبقِ حالة الشركة وتفويض العمل وفحوص وصول الأفراد منفصلة.",
  'ctr.ui.newPermit': "+ تصريح عمل جديد",
  'ctr.ui.permitQueue': "قائمة مراجعة التصاريح",
  'ctr.ui.permitQueueSub': "الاعتماد هنا لا يتجاوز هوية الزائر أو اعتماد الزيارة.",
  'ctr.ui.view.queue': "بانتظار قرار",
  'ctr.ui.view.all': "الكل",
  'ctr.ui.view.review': "للمراجعة",
  'ctr.ui.view.expiring': "مهام الانتهاء",
  'ctr.ui.noPermits': "لا توجد تصاريح في هذا العرض.",
  'ctr.col.permit': "التصريح",
  'ctr.col.companyZone': "الشركة / المنطقة",
  'ctr.col.window': "المدة",
  'ctr.col.evidence': "الإثبات",
  'ctr.col.status': "الحالة",
  'ctr.col.action': "الإجراء",
  'ctr.col.reference': "المرجع",
  'ctr.col.company': "الشركة",
  'ctr.col.dates': "التواريخ",
  'ctr.col.owner': "المسؤول",
  'ctr.col.workers': "العمال",
  'ctr.col.companyEvidence': "إثباتات الشركة",
  'ctr.col.subject': "الجهة",
  'ctr.col.state': "الحالة",
  'ctr.col.validity': "الصلاحية",
  'ctr.col.review': "المراجعة",
  'ctr.col.expires': "ينتهي",
  'ctr.col.replacement': "البديل",
  'ctr.col.task': "المهمة",
  'ctr.col.visit': "الزيارة",
  'ctr.col.observed': "الحقائق الحالية",
  'ctr.col.type': "النوع",
  'ctr.col.siteSpecific': "لكل موقع",
  'ctr.col.expiryRequired': "الانتهاء مطلوب",
  'ctr.col.leadDays': "مهلة التنبيه (أيام)",
  'ctr.col.requires': "يتطلب",
  'ctr.col.maxDays': "الحد الأقصى للأيام",
  'ctr.col.zoneDependent': "مرتبط بالمنطقة",
  'ctr.col.active': "نشط",
  'ctr.ui.evidenceReady': "الإثباتات جاهزة",
  'ctr.ui.evidenceNotReady': "الإثباتات غير جاهزة",
  'ctr.ui.reviewPermit': "مراجعة التصريح",
  'ctr.ui.workPackages': "حزم العمل",
  'ctr.ui.workPackagesSub': "العقد وأمر الشراء/المشروع والنطاق والتواريخ والمسؤول. التفاصيل التجارية مرئية لمديري المقاولين فقط.",
  'ctr.ui.newWorkPackage': "+ حزمة عمل جديدة",
  'ctr.ui.newWorkPackageTitle': "حزمة عمل جديدة",
  'ctr.ui.noWorkPackages': "لا توجد حزم عمل في هذا الموقع بعد.",
  'ctr.ui.openWorkPackage': "فتح",
  'ctr.ui.inactive': "غير نشط",
  'ctr.ui.openEnded': "دون نهاية",
  'ctr.ui.draftPermit': "مسودة تصريح عمل",
  'ctr.ui.draftPermitSub': "تفويض العمل لا يحل محل فحوص الزوار الفردية.",
  'ctr.ui.createPermit': "إنشاء التصريح",
  'ctr.ui.chooseCompanyFirst': "اختر شركة لعرض عمالها الحاليين.",
  'ctr.f.permitType': "نوع التصريح",
  'ctr.f.company': "الشركة",
  'ctr.f.workScope': "نطاق العمل",
  'ctr.f.zone': "المنطقة",
  'ctr.f.workPackage': "حزمة العمل",
  'ctr.f.validFrom': "صالح من",
  'ctr.f.validUntil': "صالح حتى",
  'ctr.f.validFromTime': "وقت البدء",
  'ctr.f.validUntilTime': "وقت الانتهاء",
  'ctr.f.issuer': "جهة الإصدار",
  'ctr.f.workers': "العمال",
  'ctr.f.worker': "العامل",
  'ctr.f.permitDecision': "قرار التصريح",
  'ctr.f.contractRef': "مرجع العقد",
  'ctr.f.scope': "النطاق",
  'ctr.f.startsOn': "يبدأ في",
  'ctr.f.endsOn': "ينتهي في",
  'ctr.f.owner': "المسؤول",
  'ctr.f.purchaseOrder': "أمر الشراء / المشروع",
  'ctr.f.commercialNote': "ملاحظة تجارية",
  'ctr.f.accountableHost': "المضيف المسؤول",
  'ctr.f.category': "فئة الزوار",
  'ctr.f.destination': "الوجهة",
  'ctr.f.dailyStart': "بداية اليوم",
  'ctr.f.dailyEnd': "نهاية اليوم",
  'ctr.f.weekdays': "أيام الأسبوع",
  'ctr.f.exclusions': "التواريخ المستثناة",
  'ctr.f.kind': "النوع",
  'ctr.f.registrationRef': "التسجيل (الرخصة التجارية)",
  'ctr.f.contactName': "جهة الاتصال",
  'ctr.f.contactEmail': "البريد الإلكتروني",
  'ctr.f.contactPhone': "الهاتف",
  'ctr.f.sponsor': "الراعي",
  'ctr.f.backupSponsor': "الراعي البديل",
  'ctr.f.department': "القسم",
  'ctr.f.effectiveFrom': "ساري من",
  'ctr.f.companyState': "حالة الشركة",
  'ctr.f.givenName': "الاسم الأول",
  'ctr.f.familyName': "اسم العائلة",
  'ctr.f.mobile': "الجوال",
  'ctr.f.role': "الدور",
  'ctr.f.resolution': "ما الذي تم",
  'ctr.f.evidenceType': "نوع الإثبات",
  'ctr.f.site': "الموقع",
  'ctr.f.source': "المصدر",
  'ctr.f.documentRef': "رقم المستند",
  'ctr.f.validFromDate': "صالح من",
  'ctr.f.validUntilDate': "ينتهي في",
  'ctr.f.evidenceOutcome': "نتيجة الإثبات",
  'ctr.f.versionNote': "ملاحظة الإصدار",
  'ctr.ui.reviewWorkPermit': "مراجعة تصريح العمل",
  'ctr.ui.permitBoundary': "لا يحل التصريح محل فحوص الزوار الفردية ولا يأذن بالدخول وحده أبدًا.",
  'ctr.ui.evidenceForPermit': "إثباتات هذا التصريح",
  'ctr.ui.decisions': "القرارات",
  'ctr.ui.revision': "النسخة {n}",
  'ctr.ui.ownSubmission': "أنت من أعدّ هذا التصريح أو قدّمه، لذا يجب أن يقرّر فيه مراجع آخر.",
  'ctr.ui.approveNeedsEvidence': "يُرفض الاعتماد حتى تُقبل إثباتات كل عامل مذكور وتكون صالحة طوال مدة التصريح.",
  'ctr.ui.reasonHintReject': "مطلوب عند الرفض.",
  'ctr.ui.recordDecision': "تسجيل قرار التصريح",
  'ctr.ui.permitAdmin': "إدارة التصريح",
  'ctr.ui.submitPermit': "تقديم للمراجعة",
  'ctr.ui.moveZone': "نقل إلى منطقة…",
  'ctr.ui.changeZone': "تغيير المنطقة",
  'ctr.ui.withdrawPermit': "سحب",
  'ctr.ui.reasonFirst': "اذكر السبب أولًا.",
  'ctr.ui.zoneChangeWarning': "تغيير منطقة تصريح معتمد يُبطل قراره؛ ويجب مراجعته مجددًا.",
  'ctr.ui.commercialHint': "تظهر لمديري المقاولين في هذا الموقع فقط.",
  'ctr.ui.createWorkPackage': "إنشاء حزمة العمل",
  'ctr.ui.accessPeriods': "فترات الدخول المتكررة",
  'ctr.ui.accessPeriodsSub': "تُنشأ الزيارات كمسودات ضمن حدود العقد والفترة وأيام الأسبوع؛ ويقدّمها المضيف للاعتماد.",
  'ctr.ui.materialised': "تم إنشاء {created} زيارة مسودة؛ و{skipped} تاريخ كان له زيارة بالفعل.",
  'ctr.ui.noPeriods': "لا توجد فترات دخول بعد.",
  'ctr.ui.periodCounts': "{remaining} تاريخ متبقٍ · {done} زيارة أُنشئت",
  'ctr.ui.materialise': "إنشاء زيارات مسودة",
  'ctr.ui.newPeriod': "+ فترة دخول جديدة",
  'ctr.ui.contractChanges': "تغييرات العقد",
  'ctr.ui.renewHint': "تمديد العقد لا يمدد فترات الدخول الحالية — أنشئ فترة جديدة.",
  'ctr.ui.saveDates': "حفظ التواريخ",
  'ctr.ui.closeHint': "الإغلاق يوقف إنشاء مواعيد جديدة وينهي فترات الدخول. يُحتفظ بالحضور السابق.",
  'ctr.ui.closeWorkPackage': "إغلاق حزمة العمل",
  'ctr.ui.exclusionsHint': "التواريخ بصيغة YYYY-MM-DD مفصولة بفواصل أو مسافات.",
  'ctr.ui.createPeriod': "إنشاء فترة الدخول",
  'ctr.weekday.1': "الإثنين",
  'ctr.weekday.2': "الثلاثاء",
  'ctr.weekday.3': "الأربعاء",
  'ctr.weekday.4': "الخميس",
  'ctr.weekday.5': "الجمعة",
  'ctr.weekday.6': "السبت",
  'ctr.weekday.7': "الأحد",
  'ctr.ui.reassignmentNeeded': { zero: "لا توجد شركات دون راعٍ نشط.", one: "شركة واحدة ليس لها راعٍ مسؤول نشط. أعِد الإسناد قبل أي عمل جديد.", two: "شركتان ليس لهما راعٍ مسؤول نشط. أعِد الإسناد قبل أي عمل جديد.", few: "{count} شركات ليس لها راعٍ مسؤول نشط. أعِد الإسناد قبل أي عمل جديد.", many: "{count} شركة ليس لها راعٍ مسؤول نشط. أعِد الإسناد قبل أي عمل جديد.", other: "{count} شركة ليس لها راعٍ مسؤول نشط. أعِد الإسناد قبل أي عمل جديد." },
  'ctr.ui.companies': "شركات المقاولات",
  'ctr.ui.companiesSub': "تُحفظ الشركات منفصلة عن العمال الأفراد وصلاحيات الدخول.",
  'ctr.ui.registerCompany': "تسجيل شركة",
  'ctr.ui.registerCompanyTitle': "تسجيل شركة مقاولات",
  'ctr.ui.registerCompanySub': "سجل الشركة ليس صلاحية دخول. تحتاج كل شركة إلى راعٍ مسؤول.",
  'ctr.ui.noCompanies': "لا توجد شركات مقاولات بعد.",
  'ctr.ui.reassign': "مطلوب إعادة إسناد الراعي",
  'ctr.ui.chooseCompany': "اختر شركة لعرض راعيها وعمالها وإثباتاتها.",
  'ctr.ui.sponsorHint': "موظف نشط مسؤول عن هذه الشركة.",
  'ctr.ui.companySub': "حقائق الشركة، منفصلة عن الدخول.",
  'ctr.ui.backup': "البديل: {name}",
  'ctr.ui.sponsorGone': "لم يعد الراعي (وأي بديل) نشطًا. يُعلَّق العمل المستقبلي حتى يُعاد إسناد راعٍ.",
  'ctr.ui.addWorker': "إضافة عامل",
  'ctr.ui.reassignSponsor': "إعادة إسناد الراعي",
  'ctr.ui.reviewSuspension': "مراجعة أثر الإيقاف",
  'ctr.ui.reinstate': "إعادة التفعيل",
  'ctr.ui.reinstateSub': "إعادة التفعيل لا تعالج مهام الاسترداد ولا تعيد التصاريح المُبطلة.",
  'ctr.ui.workers': "العمال الحاليون",
  'ctr.ui.noWorkers': "لا يوجد عمال حاليون.",
  'ctr.ui.since': "منذ",
  'ctr.ui.workerProfile': "الملف",
  'ctr.ui.formerWorkers': "العمال السابقون",
  'ctr.ui.sponsorHistory': "سجل الرعاة",
  'ctr.ui.suspensions': "حالات الإيقاف",
  'ctr.ui.lifted': "رُفع",
  'ctr.ui.mobileHint': "قد تتطلب زيارات المقاولين رقم جوال.",
  'ctr.ui.suspendTitle': "إيقاف {name}",
  'ctr.ui.suspendSub': "الأثر: تُمنع تسجيلات دخول المقاولين المستقبلية؛ ولا يُعاد كتابة الحضور القائم.",
  'ctr.ui.suspendWarning': "أي دخول منطقي نشط يتطلب مهمة استرداد منفصلة. هذا لا يعني المغادرة أو نجاح الإلغاء.",
  'ctr.ui.confirmImpact': "راجعت الأثر. ستُفتح مهام استرداد لكل زيارة متأثرة.",
  'ctr.ui.suspend': "إيقاف",
  'ctr.ui.suspendNeedsAuthority': "يتطلب الإيقاف صلاحية إيقاف المقاولين (دور متخصص يسنده مسؤول المؤسسة).",
  'ctr.impact.futureVisits': "زيارات مستقبلية أو جارية",
  'ctr.impact.observedOnsite': "موجودون في الموقع الآن",
  'ctr.impact.activeCredentials': "دخول نشط أو غير معروف",
  'ctr.impact.permits': "تصاريح ستُبطل",
  'ctr.ui.workerSub': "الشخص والشركة والدور والإثباتات وسجل الزيارات.",
  'ctr.ui.eligibilityCheck': "فحص المدة والإثباتات",
  'ctr.ui.eligibilityCheckSub': "يُقيَّم مقابل الإثباتات الحالية طوال المدة كاملة، في هذا الموقع.",
  'ctr.ui.checkEligibility': "فحص",
  'ctr.ui.noEvidence': "لا توجد إثباتات مسجّلة.",
  'ctr.ui.superseded': "مُستبدل",
  'ctr.ui.history': "سجل العمل والزيارات",
  'ctr.ui.partialScope': "لا تظهر الزيارات في مواقع خارج نطاقك.",
  'ctr.ui.moveWorker': "النقل إلى شركة أخرى",
  'ctr.ui.moveWorkerSub': "يبدأ ارتباط جديد؛ ولا تنتقل تصاريح الشركة القديمة وإثباتات الارتباط وفترات الدخول.",
  'ctr.ui.recovery': "أعمال الاسترداد بعد الإيقاف",
  'ctr.ui.recoverySub': "متابعات مفتوحة أنشأتها حالات الإيقاف. تظهر حقائق الحضور والدخول كما هي الآن.",
  'ctr.ui.resolve': "معالجة",
  'ctr.ui.resolveSub': "سجّل ما تم. المعالجة لا تغيّر حقائق الحضور أو الدخول.",
  'ctr.task.review_visit': "مراجعة زيارة مستقبلية",
  'ctr.task.revoke_access': "طلب إلغاء الدخول",
  'ctr.task.occupant_onsite': "شخص لا يزال في الموقع",
  'ctr.ui.noScanner': "لم يُعدّ فاحص للبرمجيات الضارة بعد: تبقى الملفات المرفوعة غير متاحة للمعاينة والقبول. يمكن للمراجعين قبول مستند أصلي اطّلعوا عليه شخصيًا.",
  'ctr.ui.evidenceTitle': "الإثباتات والتعريف",
  'ctr.ui.evidenceSub': "المستند المستلم ليس مستندًا مقبولًا.",
  'ctr.ui.addEvidence': "+ إضافة إثبات",
  'ctr.ui.noExpiry': "لا توجد تنبيهات انتهاء.",
  'ctr.ui.alertDue': "تنبيه {date} (قبل {days} يومًا)",
  'ctr.ui.reviewEvidence': "مراجعة الإثبات",
  'ctr.ui.inspect': "فحص",
  'ctr.ui.reviewEvidenceTitle': "مراجعة الإثبات",
  'ctr.ui.scan': "الفحص",
  'ctr.ui.review': "المراجعة",
  'ctr.ui.validity': "الصلاحية",
  'ctr.ui.openFile': "فتح المستند",
  'ctr.ui.previewBlocked': "لم يجتز الملف فحص البرمجيات الضارة، لذلك لا يمكن معاينته أو قبوله.",
  'ctr.ui.originalSighted': "سُجّل من مستند أصلي شوهد شخصيًا؛ لا يُحفظ أي ملف.",
  'ctr.ui.reviewBlockedScan': "المراجعة معلّقة حتى يُستلم ملف ويجتاز فحص البرمجيات الضارة.",
  'ctr.ui.reviewNotYours': "يجب أن يقرّر في هذا مراجع آخر: أنت قدّمته أو أنه خارج نطاق مراجعتك.",
  'ctr.ui.accept': "قبول",
  'ctr.ui.reject': "رفض",
  'ctr.ui.recordReview': "تسجيل المراجعة",
  'ctr.ui.replace': "تقديم بديل",
  'ctr.ui.replaceTitle': "تقديم إثبات بديل",
  'ctr.ui.uploadFile': "إرفاق ملف",
  'ctr.ui.uploadHint': "PDF أو PNG أو JPEG حتى 5 ميغابايت. يُفحص من المحتوى ثم يُحتجز لفحص البرمجيات الضارة.",
  'ctr.ui.upload': "رفع",
  'ctr.ui.siteSpecificHint': "يُحتسب التعريف فقط في الموقع الذي أُعطي له.",
  'ctr.ui.uploadThenScan': "يمكنك إرفاق الملف بعد ذلك. ويبقى غير متاح حتى يجتاز فحص البرمجيات الضارة.",
  'ctr.ui.sightedHint': "اطّلعت على المستند الأصلي. ولا يزال على مراجع آخر قبوله.",
  'ctr.ui.submitEvidence': "تقديم للمراجعة",
  'ctr.source.upload': "ملف مرفوع",
  'ctr.source.original_sighted': "أصل شوهد",
  'ctr.subject.company': "الشركة",
  'ctr.subject.affiliation': "العامل لدى هذه الشركة",
  'ctr.subject.person': "الشخص",
  'ctr.ui.rulesNote': "الإصدار {n} سارٍ. تُصاغ التغييرات وتُنشر كإصدار جديد؛ وتحتفظ الإثباتات والتصاريح بالإصدار الذي أُنشئت بموجبه.",
  'ctr.ui.evidenceTypes': "أنواع الإثبات",
  'ctr.ui.evidenceTypesSub': "عمّن يكون الإثبات، وهل هو لكل موقع، ومتى تبدأ التنبيهات.",
  'ctr.ui.rules': "المتطلبات حسب فئة الزوار",
  'ctr.ui.rulesSub': "الإثباتات المطلوبة لكل فئة مقاولين، وتُفحص طوال مدة الزيارة.",
  'ctr.ui.restrictedRequiresPermit': "تحتاج الوجهات المقيدة أيضًا إلى تصريح معتمد يغطي الزيارة",
  'ctr.ui.requireSponsor': "تحتاج الشركات إلى راعٍ مسؤول نشط",
  'ctr.ui.permitTypes': "أنواع التصاريح",
  'ctr.ui.permitTypesSub': "الإثباتات التي يحتاجها كل عامل مذكور، والمدة القصوى، وهل يُبطل تغيير المنطقة الاعتماد.",
  'ctr.ui.saveDraft': "حفظ المسودة",
  'ctr.ui.publish': "نشر الإصدار {n}",
  'ctr.ui.discardDraft': "تجاهل المسودة",
  'ctr.ui.unsaved': "لديك تغييرات غير محفوظة.",
  'ctr.ui.versionHistory': "سجل الإصدارات",
  'ctr.ui.versionN': "الإصدار {n}",
  'ctr.kind.contractor': "مقاول",
  'ctr.kind.vendor': "مورّد",
  'ctr.kindOf.insurance': "تأمين",
  'ctr.kindOf.licence': "رخصة",
  'ctr.kindOf.noc': "عدم ممانعة",
  'ctr.kindOf.certification': "شهادة",
  'ctr.kindOf.induction': "تعريف",
  'ctr.kindOf.training': "تدريب",
  'ctr.kindOf.other': "أخرى",
  'ctr.invalidated.zone_changed': "تغيّرت منطقة العمل بعد الاعتماد",
  'ctr.invalidated.window_changed': "تغيّرت المدة بعد الاعتماد",
  'ctr.invalidated.scope_changed': "تغيّر النطاق بعد الاعتماد",
  'ctr.invalidated.workers_changed': "تغيّر العمال المذكورون بعد الاعتماد",
  'ctr.invalidated.company_suspended': "الشركة موقوفة",
  'ctr.invalidated.work_package_closed': "حزمة العمل مغلقة",
  'ctr.ui.noRequirements': "لا تنطبق أي متطلبات.",
  'ctr.ui.validUntil': "صالح حتى",
  'ctr.ui.notGoverned': "لا توجد متطلبات مقاولين لفئة الزوار هذه.",
  'ctr.ui.eligible': "فحوص المقاول مستوفاة",
  'ctr.ui.notEligible': "فحوص المقاول غير مستوفاة",
  'ctr.ui.permitCovers': "تصريح معتمد يغطي ذلك",
  'ctr.ui.permitMissing': "التصريح مطلوب",
  'ctr.ui.requirementSet': "إصدار المتطلبات {n}",
  'ctr.ui.readinessTitle': "جاهزية المقاولين",
  'ctr.ui.readinessSub': "إثباتات الشركة والشخص والموقع طوال مدة الزيارة. اعتماد الزيارة والحضور حقائق منفصلة.",
  'ctr.status.permit.draft': "مسودة",
  'ctr.status.permit.submitted': "المراجعة مطلوبة",
  'ctr.status.permit.approved': "معتمد",
  'ctr.status.permit.rejected': "مرفوض",
  'ctr.status.permit.invalidated': "مُبطل",
  'ctr.status.permit.withdrawn': "مسحوب",
  'ctr.status.company.active': "نشطة",
  'ctr.status.company.suspended': "موقوفة",
  'ctr.status.company.inactive': "غير نشطة",
  'ctr.status.workPackage.active': "نشطة",
  'ctr.status.workPackage.closed': "مغلقة",
  'ctr.status.period.active': "نشطة",
  'ctr.status.period.ended': "منتهية",
  'ctr.status.alert.scheduled': "مجدول",
  'ctr.status.alert.raised': "صادر",
  'ctr.status.alert.cancelled': "ملغى (استُبدل)",
  'ctr.status.review.pending': "المراجعة قيد الانتظار",
  'ctr.status.review.accepted': "مقبول",
  'ctr.status.review.rejected': "مرفوض",
  'ctr.status.scan.no_file': "لا يوجد ملف بعد",
  'ctr.status.scan.pending': "الفحص قيد الانتظار",
  'ctr.status.scan.clean': "اجتاز الفحص",
  'ctr.status.scan.infected': "رُفض في فحص البرمجيات الضارة", // PD-707: صياغة محايدة
  'ctr.status.scan.failed': "لم يكتمل فحص البرمجيات الضارة",
  'ctr.status.scan.not_applicable': "لا ملف (أصل شوهد)",
  'ctr.status.package.pending': "قيد الانتظار",
  'ctr.status.package.handed_over': "سُلّم",
  'ctr.status.package.refused': "مرفوض",
  'ctr.status.package.cancelled': "ملغى",
  'ctr.status.notice.queued': "في الانتظار",
  'ctr.status.notice.accepted': "قبلتها خدمة البريد",
  'ctr.status.notice.failed': "فشل",
  'ctr.status.notice.blocked': "لم تُرسل",
  'ctr.status.area.open': "مفتوحة",
  'ctr.status.area.closed': "مغلقة",
  'ctr.status.version.draft': "مسودة",
  'ctr.status.version.published': "منشور",
  'ctr.status.version.superseded': "مُستبدل",
  'ctr.status.version.discarded': "مُتجاهَل",
  'dlv.intro': "تتبّع التواصل مع المستلم والتسليم الفعلي كنتيجتين مختلفتين.",
  'dlv.register': "+ تسجيل شحنة",
  'dlv.expect': "توقّع شحنة",
  'dlv.m.open': "طرود بالانتظار",
  'dlv.m.openSub': "وصلت ولم تُسجّل النتيجة",
  'dlv.m.awaitingDeparture': "بانتظار المغادرة",
  'dlv.m.awaitingDepartureSub': "الطرد مُغلق؛ والمندوب أو المركبة لا يزالان هنا",
  'dlv.m.unknownRecipient': "مستلم غير معروف",
  'dlv.m.unknownRecipientSub': "محتجزة لدى مسؤول تصعيد",
  'dlv.m.expectedToday': "متوقعة اليوم",
  'dlv.m.expectedTodaySub': "معلنة ولم تصل بعد",
  'dlv.tab.open': "مكتب الشحنات",
  'dlv.tab.expected': "متوقعة",
  'dlv.tab.closed': "مغلقة",
  'dlv.tab.areas': "مناطق التسليم",
  'dlv.tab.mine': "شحناتي",
  'dlv.mine': "الشحنات الخاصة بك",
  'dlv.mineSub': "يخبرك الإشعار بأن شحنة بالانتظار؛ ويسجّل المكتب التسليم.",
  'dlv.desk': "مكتب الشحنات",
  'dlv.deskSub': "تُرسل إشعارات المستلمين عبر خدمة البريد؛ والإشعار ليس تسليمًا أبدًا.",
  'dlv.empty': "لا توجد شحنات في هذا العرض.",
  'dlv.col.reference': "المرجع",
  'dlv.col.courier': "المندوب / المستلم",
  'dlv.col.package': "الطرد",
  'dlv.col.handover': "التسليم",
  'dlv.col.people': "المندوب / المركبة",
  'dlv.col.action': "الإجراء",
  'dlv.separateNote': "يجب رصد مغادرة المندوب وخروج المركبة بشكل منفصل. تسليم الطرد لا يثبت أيًا من الحركتين.",
  'dlv.expectedOn': "متوقعة",
  'dlv.for': "لـ {name}",
  'dlv.unknownRecipient': "المستلم غير معروف ({stated})",
  'dlv.packages': { zero: "لا طرود", one: "طرد واحد", two: "طردان", few: "{count} طرود", many: "{count} طردًا", other: "{count} طرد" },
  'dlv.notice': "الإشعار",
  'dlv.vehicle': "المركبة",
  'dlv.courier': "المندوب",
  'dlv.recordHandover': "تسجيل التسليم",
  'dlv.expectTitle': "توقّع شحنة",
  'dlv.expectSub': "يسجّل المكتب وصولها؛ ولا يُرسل شيء إلى المندوب.",
  'dlv.registerTitle': "تسجيل شحنة",
  'dlv.registerSub': "يُوجَّه المندوب إلى منطقة تسليم معتمدة، وليس إلى مسار الزوار أبدًا.",
  'dlv.f.courier': "شركة التوصيل",
  'dlv.f.driver': "السائق",
  'dlv.f.vehicle': "لوحة المركبة",
  'dlv.f.packageRef': "مرجع الطرد",
  'dlv.f.count': "الطرود",
  'dlv.f.expectedOn': "متوقعة في",
  'dlv.f.recipient': "المستلم",
  'dlv.f.stated': "المستلم كما ذُكر",
  'dlv.f.area': "منطقة التسليم",
  'dlv.f.note': "ملاحظة",
  'dlv.f.owner': "مسؤول التصعيد",
  'dlv.f.handedTo': "سُلّم إلى",
  'dlv.f.handedToName': "اسم الشخص الذي استلمه",
  'dlv.f.refusal': "سبب الرفض",
  'dlv.f.location': "الموقع",
  'dlv.f.priority': "الأولوية",
  'dlv.f.route': "المسار",
  'dlv.f.contact': "جهة الاتصال",
  'dlv.recipientHint': "اتركه غير معروف إذا لم يطابق أحد؛ وتصبح أنت مسؤول التصعيد.",
  'dlv.recipientUnknown': "غير معروف — يُحتجز للتصعيد",
  'dlv.statedHint': "ما قاله المندوب، للمساعدة في تحديد المستلم لاحقًا.",
  'dlv.areaHint': "اتركه تلقائيًا لاستخدام المنطقة المفتوحة ذات الأولوية الأعلى.",
  'dlv.areaAuto': "تلقائي",
  'dlv.selfRecipient': "أنت المستلم للشحنة التي تعلن عنها.",
  'dlv.expectSave': "حفظ الشحنة المتوقعة",
  'dlv.registerSave': "تسجيل الشحنة",
  'dlv.recordTitle': "تسجيل تسليم الطرد",
  'dlv.recordSub': "تُسجّل مغادرة الشخص والمركبة بشكل منفصل.",
  'dlv.facts': "حقائق منفصلة",
  'dlv.noticeNote': "الإشعار المقبول يعني أن خدمة البريد استلمت الرسالة — لا أن المستلم قرأها أو قبل الطرد.",
  'dlv.arrive': "تسجيل الوصول",
  'dlv.arriveSave': "وصل المندوب",
  'dlv.someoneElse': "شخص آخر (أدخل اسمًا)",
  'dlv.departures': "المغادرات",
  'dlv.courierLeft': "غادر المندوب",
  'dlv.vehicleLeft': "غادرت المركبة",
  'dlv.recipientContact': "التواصل مع المستلم",
  'dlv.assign': "إسناد المستلم",
  'dlv.resend': "إعادة إرسال الإشعار",
  'dlv.escalate': "تصعيد",
  'dlv.cancel': "إلغاء الشحنة المتوقعة",
  'dlv.notices': "الإشعارات",
  'dlv.trail': "سجل العهدة",
  'dlv.system': "النظام",
  'dlv.reason.no_email': "لا يوجد بريد إلكتروني للمستلم",
  'dlv.reason.recipient_inactive': "المستلم غير نشط",
  'dlv.event.registered': "سُجّلت",
  'dlv.event.expected': "أُعلن عنها",
  'dlv.event.arrived': "وصلت",
  'dlv.event.recipient_assigned': "أُسند المستلم",
  'dlv.event.escalated': "صُعّدت",
  'dlv.event.notice_queued': "الإشعار في الانتظار",
  'dlv.event.notice_accepted': "قبلت خدمة البريد الإشعار",
  'dlv.event.notice_failed': "لم يُرسل الإشعار",
  'dlv.event.handed_over': "سُلّمت",
  'dlv.event.refused': "رُفضت",
  'dlv.event.courier_departed': "غادر المندوب",
  'dlv.event.vehicle_departed': "غادرت المركبة",
  'dlv.event.cancelled': "أُلغيت",
  'dlv.areas': "مناطق التسليم المعتمدة",
  'dlv.areasSub': "يُوجَّه المندوبون إلى هنا بدلًا من مسار الزوار. تُتخطى المنطقة المغلقة؛ وعند عدم وجود منطقة مفتوحة تُرفض الشحنات.",
  'dlv.noAreas': "لا توجد منطقة تسليم مُعدّة. لا يمكن تسجيل الشحنات حتى يضيف مسؤول الموقع منطقة.",
  'dlv.priority': "الأولوية {n}",
  'dlv.capacity': "السعة نحو {n}",
  'dlv.waiting': "{n} بالانتظار هنا",
  'dlv.closeArea': "إغلاق",
  'dlv.openArea': "فتح",
  'dlv.priorityHint': "تُستخدم الأرقام الأصغر أولًا.",
  'dlv.view': 'عرض',
  'dlv.addArea': "إضافة منطقة تسليم",
};
